import * as Sentry from '@sentry/browser';
import { VERSION } from '../env/environment.js';

const SENTRY_TAGS = {
    application: 'cart-service-provider',
    applicationVersion: VERSION,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const captureException = (error) => {
    Sentry.captureException(error, { tags: SENTRY_TAGS });
    console.error(error);
};

export { captureException };
//# sourceMappingURL=sentryService.js.map
